// import React, { useState, useEffect } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import Select from '../../../components/ui/Select';
// import api from '../../../api/axios';

// const EditKnowledgeBasePane = ({ isOpen, onClose, knowledgeBase, availableAgents }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     type: '',
//     link: '',
//     document: null,
//     usedByAgents: []
//   });
//   const [showSuccess, setShowSuccess] = useState(false);

//   useEffect(() => {
//     if (knowledgeBase) {
//       setFormData({
//         name: knowledgeBase?.name || '',
//         type: knowledgeBase?.type || '',
//         link: knowledgeBase?.link || '',
//         document: null,
//         usedByAgents: knowledgeBase?.usedByAgents?.map(agent => 
//           availableAgents?.find(a => a?.name === agent)?.id
//         )?.filter(Boolean) || []
//       });
//     }
//   }, [knowledgeBase, availableAgents]);

//   const agentOptions = availableAgents?.map(agent => ({
//     value: agent?.id,
//     label: agent?.name
//   })) || [];

//   const handleChange = (e) => {
//     const { name, value } = e?.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleAgentsChange = (value) => {
//     setFormData(prev => ({ ...prev, usedByAgents: value }));
//   };

//   const handleFileChange = (e) => {
//     const file = e?.target?.files?.[0];
//     if (file) {
//       setFormData(prev => ({ ...prev, document: file }));
//     }
//   };

//   // const handleSubmit = (e) => {
//   //   e?.preventDefault();
//   //   setShowSuccess(true);
//   //   setTimeout(() => {
//   //     setShowSuccess(false);
//   //     onClose();
//   //   }, 2000);
//   // };


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   const formDataPayload = new FormData();

//   formDataPayload.append('knowledgeBaseName', formData.name);
//   formDataPayload.append('knowledgeBaseType', formData.type);

//   if (formData.type === 'Link') {
//     formDataPayload.append('url', formData.link);
//   }

//   if (formData.type === 'Doc' && formData.document) {
//     formDataPayload.append('file', formData.document);
//   }

//   // IMPORTANT: send agentIds one by one
//   formData.usedByAgents.forEach(agentId => {
//     formDataPayload.append('agentIds', agentId);
//   });

//   try {
//     await api.patch(
//       `/api/v1/dashboard/update-knowledge-base/${knowledgeBase.id}`,
//       formDataPayload,
//       {
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       }
//     );

//     setShowSuccess(true);
//     setTimeout(() => {
//       setShowSuccess(false);
//       onClose();
//     }, 2000);

//   } catch (err) {
//     console.error(err);
//   }
// };


//   const isValidInput = formData?.name && 
//                        ((formData?.type === 'Link' && formData?.link) || 
//                         (formData?.type === 'Doc' && (knowledgeBase?.link || formData?.document))) &&
//                        formData?.usedByAgents?.length > 0;

//   if (!isOpen || !knowledgeBase) return null;

//   return (
//     <>
//       <div
//         className="fixed inset-0 bg-black/50 z-[400] transition-opacity"
//         onClick={onClose}
//       />
//       <div className="fixed top-0 right-0 h-full w-full md:w-[700px] lg:w-[800px] bg-card border-l border-border z-[500] overflow-y-auto shadow-2xl transform transition-transform">
//         <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 z-10">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
//                 <Icon name="Edit" size={20} className="text-primary" />
//               </div>
//               <div>
//                 <h2 className="text-lg md:text-xl font-semibold text-foreground">Edit Knowledge Base</h2>
//                 <p className="text-xs md:text-sm text-muted-foreground">{knowledgeBase?.name}</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-muted transition-base"
//               aria-label="Close panel"
//             >
//               <Icon name="X" size={20} />
//             </button>
//           </div>
//         </div>

//         <div className="p-4 md:p-6">
//           {/* Success Message */}
//           {showSuccess && (
//             <div className="mb-6 p-4 bg-success/10 border border-success rounded-lg flex items-center gap-3">
//               <Icon name="CheckCircle" size={20} className="text-success" />
//               <p className="text-sm font-medium text-success">Knowledge Base Updated Successfully</p>
//             </div>
//           )}

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="space-y-4">
//             {/* Name */}
//             <div>
//               <label className="block text-sm font-medium text-foreground mb-1.5">
//                 Name <span className="text-error">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData?.name}
//                 onChange={handleChange}
//                 required
//                 placeholder="Enter knowledge base name"
//                 className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//               />
//             </div>

//             {/* Update Link or Document */}
//             <div>
//               <label className="block text-sm font-medium text-foreground mb-1.5">
//                 Update {formData?.type === 'Link' ? 'Link' : 'Document'}
//               </label>
//               {formData?.type === 'Link' ? (
//                 <input
//                   type="url"
//                   name="link"
//                   value={formData?.link}
//                   onChange={handleChange}
//                   placeholder="https://example.com"
//                   className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                 />
//               ) : (
//                 <div>
//                   <input
//                     type="file"
//                     accept=".docx,.pdf"
//                     onChange={handleFileChange}
//                     className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                   />
//                   {formData?.document && (
//                     <p className="text-xs text-muted-foreground mt-1">
//                       New file: {formData?.document?.name}
//                     </p>
//                   )}
//                   {!formData?.document && knowledgeBase?.link && (
//                     <p className="text-xs text-muted-foreground mt-1">
//                       Current: {knowledgeBase?.link}
//                     </p>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Used By Agents */}
//             <div>
//               <label className="block text-sm font-medium text-foreground mb-1.5">
//                 Used By Agent(s) <span className="text-error">*</span>
//               </label>
//               <Select
//                 options={agentOptions}
//                 value={formData?.usedByAgents}
//                 onChange={handleAgentsChange}
//                 placeholder="Select agents"
//                 multiple
//                 searchable={true}
//                 required
//               />
//             </div>

//             {/* Submit Button */}
//             <div className="pt-2">
//               <Button
//                 type="submit"
//                 disabled={!isValidInput}
//                 fullWidth
//                 iconName="Save"
//                 className="disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Update Knowledge Base
//               </Button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EditKnowledgeBasePane;





import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import api from '../../../api/axios';

const EditKnowledgeBasePane = ({
  isOpen,
  onClose,
  knowledgeBase,
  availableAgents,
  onSuccess // ✅ added
}) => {
  // console.log(knowledgeBase)
  const [formData, setFormData] = useState({
     id: null,          // ✅ ADD THIS
    name: '',
    type: '',
    link: '',
    document: null,
    usedByAgents: []
  });
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (knowledgeBase) {
      setFormData({
        id: knowledgeBase.id,   // ✅ CRITICAL
        name: knowledgeBase?.name || '',
        type: knowledgeBase?.type || '',
        link: knowledgeBase?.link || '',
        document: null,
        usedByAgents: knowledgeBase?.usedByAgents?.map(agent =>
          availableAgents?.find(a => a?.name === agent)?.id
        )?.filter(Boolean) || []
      });
    }
  }, [knowledgeBase, availableAgents]);

  const agentOptions = availableAgents?.map(agent => ({
    value: agent?.id,
    label: agent?.name
  })) || [];

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAgentsChange = (value) => {
    setFormData(prev => ({ ...prev, usedByAgents: value }));
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      setFormData(prev => ({ ...prev, document: file }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataPayload = new FormData();
    formDataPayload.append('knowledgeBaseName', formData.name);
    formDataPayload.append('knowledgeBaseType', formData.type.toUpperCase()); // ✅ LINK / DOC

    if (formData.type === 'Link') {
      formDataPayload.append('url', formData.link);
    }

    if (formData.type === 'Doc' && formData.document) {
      formDataPayload.append('file', formData.document);
    }

    formData.usedByAgents.forEach(agentId => {
      formDataPayload.append('agentIds', agentId);
    });

    try {
      // console.log(formDataPayload)
      // console.log("---------------------------")
      // console.log(formData)
      await api.patch(
        `/api/v1/dashboard/update-knowledge-base/${formData.id}`, // ✅ real id
        formDataPayload,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        onClose();
        onSuccess?.(); // ✅ refresh list
      }, 2000);

    } catch (err) {
      console.error(err);
    }
  };

  const isValidInput =
    formData?.name &&
    ((formData?.type === 'Link' && formData?.link) ||
      (formData?.type === 'Doc' && (knowledgeBase?.link || formData?.document))) &&
    formData?.usedByAgents?.length > 0;

  if (!isOpen || !knowledgeBase) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[400] transition-opacity"
        onClick={onClose}
      />
      <div className="fixed top-0 right-0 h-full w-full md:w-[700px] lg:w-[800px] bg-card border-l border-border z-[500] overflow-y-auto shadow-2xl transform transition-transform">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 z-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
                <Icon name="Edit" size={20} className="text-primary" />
              </div>
              <div>
                <h2 className="text-lg md:text-xl font-semibold text-foreground">Edit Knowledge Base</h2>
                <p className="text-xs md:text-sm text-muted-foreground">{knowledgeBase?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-muted transition-base"
              aria-label="Close panel"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <div className="p-4 md:p-6">
          {/* Success Message */}
          {showSuccess && (
            <div className="mb-6 p-4 bg-success/10 border border-success rounded-lg flex items-center gap-3">
              <Icon name="CheckCircle" size={20} className="text-success" />
              <p className="text-sm font-medium text-success">Knowledge Base Updated Successfully</p>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1.5">
                Name <span className="text-error">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData?.name}
                onChange={handleChange}
                required
                placeholder="Enter knowledge base name"
                className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>

            {/* Update Link or Document */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1.5">
                Update {formData?.type === 'Link' ? 'Link' : 'Document'}
              </label>
              {formData?.type === 'Link' ? (
                <input
                  type="url"
                  name="link"
                  value={formData?.link}
                  onChange={handleChange}
                  placeholder="https://example.com"
                  className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              ) : (
                <div>
                  <input
                    type="file"
                    accept=".docx,.pdf"
                    onChange={handleFileChange}
                    className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                  {formData?.document && (
                    <p className="text-xs text-muted-foreground mt-1">
                      New file: {formData?.document?.name}
                    </p>
                  )}
                  {!formData?.document && knowledgeBase?.link && (
                    <p className="text-xs text-muted-foreground mt-1">
                      Current: {knowledgeBase?.link}
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Used By Agents */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1.5">
                Used By Agent(s) <span className="text-error">*</span>
              </label>
              <Select
                options={agentOptions}
                value={formData?.usedByAgents}
                onChange={handleAgentsChange}
                placeholder="Select agents"
                multiple
                searchable={true}
                required
              />
            </div>

            {/* Submit Button */}
            <div className="pt-2">
              <Button
                type="submit"
                disabled={!isValidInput}
                fullWidth
                iconName="Save"
                className="disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Update Knowledge Base
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditKnowledgeBasePane;
